class Privilege {
  id?: number = 0;
  name: string = "";
}

export default Privilege;
